import ModalRaiting from './ModalRaiting';

export default ModalRaiting;
